import React from 'react';
import './index.scss';
import { BaSeAccountProfile, BaSeFooter, BaSeRoot } from "@base/react";
import packageJson from '../../../../package.json';
import AuthContext from '../../../auth/index';
import { useHistory } from "react-router-dom";

const Home = (props) => {
    console.log('props', props);
    console.log('props', props.authenticated);
    const history = useHistory();

    React.useEffect(_ => {
        if (props.authenticated) history.push("/dashboard");

        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AuthContext.Consumer>
            {({keycloak}) => (
                <BaSeRoot>
                    <div className='loginWrapper'>
                        <h1>
                            Bem vindo ao Gestor do App Sebrae
                        </h1>
                        <div className='container-info'>
                            <h2>
                                Aqui o gestor é capaz de configurar o melhor uso do aplicativo <strong>Sebrae na
                                palma</strong>,
                                limitando e possibilitando o acesso
                                de acordo com as necessidades e interesses.

                            </h2>
                        </div>
                        <img src='/app.png' alt='Imagem de logo do sebrae'/>
                        <h2> Se também lhe interessa o domínio do sistema , entre em contato através do
                            e-mail <strong>marcio@sebrae.com.br.</strong></h2>

                    </div>
                    <div className="container-login-button">
                        <BaSeAccountProfile keycloak={keycloak}/>
                    </div>

                    <div style={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%'
                    }}>
                        <BaSeFooter

                            relationText="Central de Relacionamento:"
                            relationLink={{label: ' 0800 570 0800', link: 'tel:08005700800'}}
                            systemName={`${packageJson.name}`}
                            systemVersion={`${packageJson.version}`}
                            links={[
                                {
                                    label: 'Conheça o Sebrae',
                                    link: 'https://sebrae.com.br/sites/PortalSebrae',
                                },
                                {
                                    label: 'Conheça o App Sebrae',
                                    link: 'https://www.sebrae.com.br/sites/PortalSebrae/aplicativosebrae',
                                },
                            ]}
                        />
                    </div>
                </BaSeRoot>
            )}
        </AuthContext.Consumer>
    )
}

export default Home;
